import { cn } from '#app/utils/misc'

type BaseProps = {
	className?: string
}
type LogoVariant =
	| 'vertical-color'
	| 'vertical-bw'
	| 'horizontal-color'
	| 'horizontal-bw'
	| 'x-color'
	| 'x-bw'

function XManVerticalColor({ className }: BaseProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 347.78 501.04"
			className={cn('h-8 fill-accent-purple sm:h-10', className)}
		>
			<title>X̂ Man</title>
			<g>
				<g>
					<path
						d="m313.83,394.2h-41.51l-93.3-127.96-93.3,127.96h-41.51l114.7-154.5L49.76,92.48h41.51l88.16,121.12,88.16-121.12h41.09l-109.56,147.65,114.7,154.07Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
					<path
						d="m112.7,92.19L166.26.5h25.42l53.56,91.69h-33.59l-32.68-64.91-32.68,64.91h-33.59Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
				</g>
				<path
					d="m107.37,394.2v106.12h-24.08v-55.69l-20.47,38.08h-17.76l-20.32-37.18-.15,54.79H.5v-106.12h21.83l31.91,60.36,31.76-60.36h21.37Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m207.42,473.6h-56.2l-11.35,26.3h-33.32l59.26-126.99h26.3l59.44,126.99h-32.78l-11.35-26.3Zm-10.63-24.86l-17.47-40.71-17.47,40.71h34.94Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m347.28,394.2v106.35h-20.52l-48.57-60.79v60.79h-25.79v-106.35h20.21l48.72,60.79v-60.79h25.95Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
			</g>
		</svg>
	)
}

function XManVerticalBW({ className }: BaseProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 346.78 500.04"
			className={cn('h-8 fill-foreground sm:h-10', className)}
		>
			<title>X̂ Man</title>
			<g>
				<g>
					<path
						d="m313.33,393.7h-41.51l-93.3-127.96-93.3,127.96h-41.51l114.7-154.5L49.26,91.98h41.51l88.16,121.12,88.16-121.12h41.09l-109.56,147.65,114.7,154.07Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
					<path
						d="m112.2,91.69L165.76,0h25.42l53.56,91.69h-33.59l-32.68-64.91-32.68,64.91h-33.59Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
				</g>
				<path
					d="m106.87,393.7v106.12h-24.08v-55.69l-20.47,38.08h-17.76l-20.32-37.18-.15,54.79H0v-106.12h21.83l31.91,60.36,31.76-60.36h21.37Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m206.92,473.1h-56.2l-11.35,26.3h-33.32l59.26-126.99h26.3l59.44,126.99h-32.78l-11.35-26.3Zm-10.63-24.86l-17.47-40.71-17.47,40.71h34.94Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m346.78,393.7v106.35h-20.52l-48.57-60.79v60.79h-25.79v-106.35h20.21l48.72,60.79v-60.79h25.95Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
			</g>
		</svg>
	)
}

function XManHorizontalColor({ className }: BaseProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 501.57 265.8"
			className={cn('h-8 fill-accent-purple sm:h-10', className)}
		>
			<title>X̂ Man</title>
			<g>
				<g>
					<path
						d="m182.34,265.3h-27.92l-62.75-86.07-62.75,86.07H.99l77.14-103.92L4.74,62.36h27.92l59.3,81.46,59.3-81.46h27.63l-73.69,99.31,77.14,103.63Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
					<path
						d="m47.07,62.17L83.09.5h17.1l36.03,61.67h-22.59l-21.98-43.66-21.98,43.66h-22.59Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
				</g>
				<path
					d="m257.05,106.62v107.94h-24.5v-56.65l-20.82,38.74h-18.07l-20.67-37.82-.15,55.73h-24.5v-107.94h22.2l32.46,61.4,32.3-61.4h21.74Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m353.97,191.86h-47.58l-9.61,22.27h-28.21l50.17-107.51h22.27l50.32,107.51h-27.75l-9.61-22.27Zm-9-21.04l-14.79-34.46-14.79,34.46h29.58Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m501.07,106.62v108.17h-20.87l-49.41-61.83v61.83h-26.24v-108.17h20.56l49.56,61.83v-61.83h26.39Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
			</g>
		</svg>
	)
}

function XManHorizontalBW({ className }: BaseProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 500.08 264.8"
			className={cn('h-8 fill-foreground sm:h-10', className)}
		>
			<title>X̂ Man</title>
			<g>
				<g>
					<path
						d="m181.35,264.8h-27.92l-62.75-86.07-62.75,86.07H0l77.14-103.92L3.74,61.86h27.92l59.3,81.46,59.3-81.46h27.63l-73.69,99.31,77.14,103.63Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
					<path
						d="m46.07,61.67L82.1,0h17.1l36.03,61.67h-22.59l-21.98-43.66-21.98,43.66h-22.59Z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
				</g>
				<path
					d="m256.05,106.12v107.94h-24.5v-56.65l-20.82,38.74h-18.07l-20.67-37.82-.15,55.73h-24.5v-107.94h22.2l32.46,61.4,32.3-61.4h21.74Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m352.98,191.36h-47.58l-9.61,22.27h-28.21l50.17-107.51h22.27l50.32,107.51h-27.75l-9.61-22.27Zm-9-21.04l-14.79-34.46-14.79,34.46h29.58Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m500.08,106.12v108.17h-20.87l-49.41-61.83v61.83h-26.24v-108.17h20.56l49.56,61.83v-61.83h26.39Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
			</g>
		</svg>
	)
}

function XColor({ className }: BaseProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 342.1 499.5"
			className={cn('h-8 fill-accent-purple sm:h-10', className)}
		>
			<title>X̂ Man</title>
			<g>
				<g>
					<path
						d="M342.1,499.5h-52.7L171,337.2L52.7,499.5H0l145.5-196L7.1,116.7h52.7l111.9,153.7l111.9-153.7h52.1L196.6,304
			L342.1,499.5L342.1,499.5z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
					<path
						d="M86.9,116.3L154.9,0h32.2l68,116.3h-42.6L171,34l-41.5,82.4H86.9L86.9,116.3z"
						stroke="#000"
						strokeMiterlimit="10"
					/>
				</g>
			</g>
		</svg>
	)
}

function XBW({ className }: BaseProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 342.1 499.53"
			className={cn('h-8 fill-foreground sm:h-10', className)}
		>
			<title>X̂ Man</title>
			<g>
				<path
					d="m342.1,499.53h-52.67l-118.38-162.36-118.38,162.36H0l145.53-196.03L7.06,116.7h52.67l111.86,153.67,111.86-153.67h52.13l-139.01,187.34,145.53,195.49Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<path
					d="m86.91,116.34L154.87,0h32.25l67.96,116.34h-42.62l-41.47-82.36-41.47,82.36h-42.62Z"
					stroke="#000"
					strokeMiterlimit="10"
				/>
			</g>
		</svg>
	)
}

export function Logo({ type, className }: { type: LogoVariant } & BaseProps) {
	const Component = getLogo(type)
	return <Component className={className} />
}

function getLogo(type: LogoVariant) {
	switch (type) {
		case 'vertical-color':
			return XManVerticalColor
		case 'vertical-bw':
			return XManVerticalBW
		case 'horizontal-color':
			return XManHorizontalColor
		case 'horizontal-bw':
			return XManHorizontalBW
		case 'x-color':
			return XColor
		case 'x-bw':
			return XBW
		default:
			return () => null
	}
}
